query AdditionalApproverList($entityApprovalBranchId: UUID!) {
  additionalApproverList(entityApprovalBranchId: $entityApprovalBranchId) {
    nodes {
      sequenceId
      sequenceName
      channelId
      channelName
      groupId
      groupName
      userId
      userName
      isGroupHeader
      isGroupSelectable
      isDepartmentGroup
      departmentId
      departmentName
      isMessages
      isCommunicationGroup
      channelId
      isContactGroup
      sortOrder
      userOccupation
    }
  }
}
